import React from 'react';
import { LayerApi } from './LayerProvider.tsx';

// @ts-ignore
export const Layer = React.createContext<LayerApi>({});
